import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { prettyLetter } from 'pretty-letters';

gsap.registerPlugin(ScrollTrigger);

export default class NextProject {
    constructor(){
        this.section = {
            el: document.getElementById('#next-project'),
            title: document.querySelectorAll('#next-project .title'),
            button: document.querySelectorAll('#next-project button'),
            last: document.querySelector('section:nth-last-child(2)'),
        };

        this.gallery = document.getElementById('gallery'),

        this.project = {
            letters: document.querySelectorAll('#next-project .title [class*="char-"]'),
        };
    }

    init(){
        this.set();
        this.animation();
        this.interaction();
    }

    set = () => {
        this.section.title.forEach((title)=>{
            prettyLetters(title, {
                charClass: 'char-',
                groupClass: 'word-',
                charTag: 'span',
                groupTag: 'span',
            });
        })
    }

    animation = () => {
        if(Sniff.features.mobile === false){
            this.section.title.forEach((title)=>{
                gsap.from(title, 2,{
                    y: -300,
                    ease: 'expo.easeInOut',
                    scrollTrigger: {
                        trigger: this.section.last,
                        start: 'bottom bottom',
                        end: 'bottom bottom',
                    }
                });
            })
        }

        if(Sniff.features.mobile === false){
            gsap.from('#next-project .title [class*="char-"]', 2,{
                y: -200,
                autoAlpha: 0,
                stagger: .05,
                ease: 'expo.easeInOut',
                scrollTrigger: {
                    trigger: this.section.last,
                    start: '100%-=200 bottom',
                    end: 'bottom bottom',
                }
            });
        } else {
            gsap.from('#next-project .title [class*="char-"]', 1,{
                y: -100,
                autoAlpha: 0,
                stagger: .05,
                ease: 'expo.easeInOut',
                scrollTrigger: {
                    trigger: this.section.last,
                    start: '100%-=200 bottom',
                    end: 'bottom bottom',
                }
            });
        }

        this.section.button.forEach((button)=>{
            gsap.from(button, 2,{
                delay: 1,
                autoAlpha: 0,
                ease: 'expo.easeInOut',
                scrollTrigger: {
                    trigger: this.section.last,
                    start: '100%-=200 bottom',
                    end: 'bottom bottom',
                }
            });
        })
    }

    interaction = () => {
        this.section.title.forEach((title)=>{
            title.addEventListener('mouseover', () => {
                title.parentNode.querySelector('button').classList.add('hovering')
            });

            title.addEventListener('mouseleave', () => {
                title.parentNode.querySelector('button').classList.remove('hovering')
            });
        });
    }
}
